export const emailRegex = /^([\w\-'.+]+@([\w-]+\.)+[\w-]{2,4})$/;
export const zipCodeRegex = /\b\d{5}\b/;
export const zipCodeRegexExtended = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const letterRegex = /[A-Za-z]/;
export const ssnRegex = /^(?!000)(?!666)(?!9[0-9][0-9])\d{3}[- ]?(?!00)\d{2}[- ]?(?!0000)\d{4}$/;
export const phoneRegex = /^\s+$|[0-9]{3}-[0-9]{3}-[0-9]{4}|[0-9]{10}/;
export const alphaNumericRegex = /^[a-zA-Z0-9]+$/;
export const alphaNumericWhitespaceRegex = /^[a-zA-Z0-9\s]*$/;
// eslint-disable-next-line no-control-regex
export const organizationNameRegex = /^[\x20-\xFF]*$/; // Covers the Standard and Extended ASCII Charts
export const allowed2pcFileExtensionsRegex = /(\.doc|\.docx|\.jpg|\.png|\.jpeg|\.pdf|\.rtf)$/i;
export const numericRegex = /^\d+$/;
export const lastFourSSNRegex = /^\d{4}$/;
export const licenseNumberRegex = /^[a-zA-Z0-9]{1,32}$/;
export const firstLastNameRegex = /^[\w\s'’`,/.-]{1,50}$/;
export const usernameRegex = /^[\s\S]{8,50}/;
// eslint-disable-next-line max-len
export const dlNumberRegex = /^(?!000)(?!666)(?!9[0-9][0-9])[a-zA-Z0-9]{4}[- ]?\d{3}[- ]?\d{2}[- ]?\d{3}[- ]?\d{1}$/;
export const passportRegex = /^[a-z0-9]{1,15}$/i; // ICAO 9303 Part 4
export const dateRegex = /^\d{4}-\d\d-\d\d/;
export const patientIdentifierRegex = /^P[0-9ADEFHKMRTVXY]{3}[0-9]{4}/;
